/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'virtual-service-subheader';
const prefix = `${moduleName}.${componentName}`;

export const topologyLabel = `${prefix}.topologyLabel`;

export const ENGLISH = {
    [topologyLabel]: 'Topology',
};
